
import MBaseModal from "@/components/MBaseModal.vue";
import MButton from "@/components/MButton.vue";
import MTextField from "@/components/form/MTextField.vue";
import { Options, Vue } from "vue-class-component";

@Options({
  components: {
    MBaseModal,
    MButton,
    MTextField
  },
  emits: ["close", "confirm"],
  props: {
    currentEmail: String
  }
})
export default class MscChangeEmailModal extends Vue {
  currentEmail = "";
  newEmail = "";

  get validEmail(): boolean {
    if (!this.newEmail) {
      return true;
    }
    // 簡易的なメールアドレスのバリデーション
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(this.newEmail);
  }

  close() {
    this.$emit("close");
  }

  confirm() {
    if (this.validEmail && this.newEmail) {
      this.$emit("confirm", this.newEmail);
    }
  }
}
